// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__p1d6J","navlist":"navbar_navlist__1pR5I"};